<script>
import options from './ArticleAnchors.options'
export default options
</script>

<template>
  <template v-if="headerList.length">
    <nav class="kb-article-anchors">
      <strong class="kb-article-anchors__title">Oversigt</strong>
      <ul class="kb-article-anchors__list">
        <template v-for="(header, index) in headerList" :key="index">
          <li>
            <a :href="'#' + header.href">{{ header.displayName }}</a>
          </li>
        </template>
      </ul>
    </nav>
  </template>
</template>
